import type { ReactNode } from "react";

/**
 * SessionExpiredProvider — wraps the app to detect expired sessions and prompt re-login.
 * Recreated after accidental deletion. The Codex coder will expand this.
 */
export function SessionExpiredProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
